import React from 'react'
import PropTypes from 'prop-types'

const ImageWithDefault = ({ defaultSrc, alt, onError, src, ...rest }) => (
  <img
    {...rest}
    src={src || defaultSrc}
    onError={e => {
      e.target.onerror = null
      e.target.src = defaultSrc
      onError(e)
    }}
    alt={alt}
  />
)

ImageWithDefault.defaultProps = {
  onError: () => {},
}

ImageWithDefault.propTypes = {
  defaultSrc: PropTypes.string.isRequired,
}

export default ImageWithDefault
